import {Tooltip} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import {StyledBadge} from '../../header/patientInfo';
import FlagIcon from '@mui/icons-material/Flag';
import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import PatientFlags from '../../../pages/ward/forms/patientFlags';
import useOpenState from '../../../hooks/useOpenState';
import _ from 'lodash';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import clsx from 'clsx';
import {useHeaderIconStyles} from './iconStyle';

const PatientFlagsButton = ({patient, disableSave, handleSaveData}) => {
    const {t} = useTranslation();
    const classes = useHeaderIconStyles();

    const [isPatientFlagOpen, openPatientFlag, closePatientFlag] = useOpenState(false, true);

    const selectedFlags = useCallback(() => {
        const patientFlags = _.get(patient, 'metadata.patientFlags', []);
        return _.filter(patientFlags, 'checked').length;
    }, [patient]);

    return (
        <>
            <Tooltip title={t('Patient Flags')}>
                <IconButton
                    onClick={openPatientFlag}
                    size="small"
                    className={clsx(classes.iconHover, isPatientFlagOpen && classes.iconButton)}
                    disableRipple
                    color={isPatientFlagOpen ? 'primary' : 'default'}
                >
                    <StyledBadge
                        color="primary"
                        badgeContent={selectedFlags()}
                    >
                        {selectedFlags() === 0 ? <FlagOutlinedIcon/> : <FlagIcon/>}
                    </StyledBadge>
                </IconButton>
            </Tooltip>

            {isPatientFlagOpen &&
                <PatientFlags
                    open={isPatientFlagOpen}
                    patient={patient}
                    onSave={handleSaveData}
                    disableSave={disableSave}
                    onClose={closePatientFlag}
                />
            }
        </>
    );
};

export default PatientFlagsButton;